const methodsUrl = [
    {name: 'Url 1', id : 1},
    {name: 'Url 2', id : 2},
    {name: 'Url 3', id : 3},
    {name: 'Url 4', id : 4},
    {name: 'Url 5', id : 5,}
]

const methodUrlType = [
    {name: 'M3U', id:1},
    {name: 'Stalker', id:2},
    {name: 'Xtreme Code API', id:3}
]
const methodAllow = [
    {name: 'Allowed', id: 1},
    {name: 'Not Allowed', id: 2}
]
const yesNo=[
    {name: 'Yes', id: 1},
    {name: 'No', id: 2}
]
export const roles=[
    {id:1, name:'Master Admin'},
    {id:2, name:'Master Vendor'},
    {id:3, name:'Vendor User'}
]

export {methodsUrl, methodUrlType, methodAllow, yesNo}